<template>
  <el-drawer size="1200px" :visible="selfVisible" :title="detail.productName" @update:visible="visibleChange" class="product-info-drawer" :append-to-body="true">
    <div class="info-content">
      <div class="param-content">
        <div class="cur-img">
          <img :src="curImgUrl" class="img" />
        </div>
        <div class="img-group">
          <div @click="imgIndex = index - 1" class="img-item" :class="{ cur: index === imgIndex }" v-for="index in imgMaxLen" :key="index">
            <img :src="imgList[index - 1] ? imgList[index - 1].url : ''" class="img" />
          </div>
        </div>
        <ul class="param-list">
          <li class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.chan_pinSN') }}
            </div>
            <div class="param-val">{{ detail.productSn || '-' }}</div>
          </li>
          <li class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.chan_pin_xing_hao') }}
            </div>
            <div class="param-val">{{ detail.productCode || '-' }}</div>
          </li>
          <li class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.chan_pin_ming_cheng') }}
            </div>
            <div class="param-val">{{ detail.productName || '-' }}</div>
          </li>
          <li class="param-item" v-if="isAdmin">
            <div class="param-key">
              {{ $t('dms_product_info.ISTzhan_dian') }}
            </div>
            <div class="param-val">{{ detail.websiteName || '-' }}</div>
          </li>
          <li class="param-item" v-if="isAdmin">
            <div class="param-key">
              {{ $t('dms_product_info.guo_jia') }}
            </div>
            <div class="param-val">{{ detail.country || '-' }}</div>
          </li>
          <li class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.chan_pin_lei_bie') }}
            </div>
            <div class="param-val">
              <!--  -->
              {{ getDicValue('dms_product_class', detail.productClass) || '-' }}
            </div>
          </li>
          <li class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.chan_pin_lei_xing') }}
            </div>
            <div class="param-val">{{ getDicValue('dms_product_type', detail.productType) || '-' }}</div>
          </li>
          <li class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.er_ji_lei_xing') }}
            </div>
            <div class="param-val">{{ getDicValue('dms_product_sub_type', detail.productSubType) || '-' }}</div>
          </li>
          <li v-if="isAdmin" class="param-item">
            <div class="param-key">
              {{ $t('dms_product_info.cpzcgn') }}
            </div>
            <div class="param-val">{{ supportFuncView || '-' }}</div>
          </li>
          <li class="param-item">
            <div class="param-key">
              {{ $t('Common.com_status') }}
            </div>
            <div class="param-val">{{ getDicValue('cloud_valid_invalid_state', detail.productState) || '-' }}</div>
          </li>
        </ul>
        <div class="product-desc">
          {{ detail.productDesc }}
        </div>
      </div>
      <div class="component-content">
        <custom-tab :list="tabData" v-model="tabIndex" class="tab"></custom-tab>
        <div class="inner-content">
          <!-- 资源下载 -->
          <product-info-file v-if="tabIndex === 'download'" :productId="productId" :productCodeId="productCodeId"></product-info-file>
          <!-- 产品参数 -->
          <product-info-param v-if="tabIndex === 'param'" :data="modelForm" :productCodeId="productCodeId"></product-info-param>
          <!-- 产品结构 -->
          <product-info-component v-if="tabIndex === 'struct'" :data="detail"></product-info-component>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
/** 查看产品详情 */

import apis from '@/utils/apis';
import productInfoComponent from './product_info_component.vue';
import productInfoParam from './product_info_param.vue';
import productInfoFile from './product_info_file.vue';

export default {
  components: {
    productInfoComponent,
    productInfoParam,
    productInfoFile,
  },
  props: {
    productId: [Number, String],
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    brand() {
      return this.getDicValue('iot_product_brand', this.detail.productBrand);
    },
    curImgUrl() {
      const imgItem = this.imgList[this.imgIndex];
      if (imgItem) {
        return imgItem.url;
      }
      return '';
    },
    isAdmin() {
      return this.$store.state.userInfo.bizType === 'PF';
    },
    tabData() {
      const struct = this.$t('dms_product_info.chan_pin_jie_gou');
      const param = this.$t('dms_product_info.chan_pin_can_shu');
      const download = this.$t('dms_product_info.chan_pin_wen_dang');
      return [
        {
          name: struct,
          value: 'struct',
        },
        {
          name: download,
          value: 'download',
        },
        {
          name: param,
          value: 'param',
        },
        // ,
        // {
        //   name: model,
        //   value: 'model'
        // },
        // {
        //   name: protocol,
        //   value: 'protocol'
        // }
      ];
    },
    supportFuncView() {
      if (!this.detail.supportFunc) {
        return '-';
      }
      const arr = [];
      const supportFuncArr = this.detail.supportFunc && this.detail.supportFunc.split(',');
      supportFuncArr.forEach((item) => {
        const val = this.getDicValue('iot_product_support_func', item);
        arr.push(val);
      });
      return arr.join(',');
    },
    state() {
      return this.getDicValue('cloud_valid_invalid_state', this.detail.productState);
    },
    allowRegister() {
      return this.getDicValue('iot_product_allow_register', this.detail.allowRegister);
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.selfVisible = val;
      },
    },
  },
  data() {
    return {
      bizType: 'dms.product.atlas',
      imgMainType: 'dms.product.icon',
      detail: {},
      modelForm: {},
      imgList: [],
      imgMaxLen: 4,
      imgIndex: 0,
      tabIndex: 'struct',
      selfVisible: false,
      productCodeId: '',
      productCode: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    visibleChange(val) {
      if (val) {
        this.$emit('update:visible', val);
      } else {
        this.selfVisible = false;
        setTimeout(() => {
          this.$emit('update:visible', val);
        }, 300);
      }
    },
    init() {
      this.getProductDetail();
    },
    getProductDetail() {
      this.$getJSON(apis.ProductDetail, {
        productId: this.productId,
      }).then((res) => {
        this.detail = res.data;
        this.productCodeId = this.detail.productCodeId;
        this.modelForm = JSON.parse(res.data.cleanWheelParam || '{}');
        this.getOssAttach();
      });
    },
    getOssAttach() {
      const getMainImg = this.$getFileList({
        bizId: this.detail.productCodeId,
        bizType: this.imgMainType,
      });
      const getImg = this.$getFileList({
        bizId: this.detail.productCodeId,
        bizType: this.bizType,
      });
      const multPromise = Promise.all([getMainImg, getImg]);
      multPromise.then((resList) => {
        // 主图
        const mainImgList = resList[0];
        const imgList = resList[1];
        this.imgList = [...mainImgList, ...imgList];
      });
    },
  },
};
</script>

<style lang="scss">
.product-info-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;
  span[role='heading']:focus {
    outline: none;
  }

  .el-drawer__body {
    padding: 0px;
  }

  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;

    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .el-drawer__body {
    position: relative;
  }

  .info-content {
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    .param-content {
      width: 408px;
      flex-shrink: 0;
      padding: 24px;
      overflow-y: auto;
      background: #f8f9fb;

      .cur-img {
        $r: 360px;
        width: $r;
        height: $r;
        position: relative;
        background: #fff;
      }

      .img-group {
        margin-top: 13px;
        margin-bottom: 24px;
        display: flex;
        justify-content: space-between;
        width: 360px;

        .img-item {
          width: 80px;
          height: 82px;
          position: relative;
          background: #fff;
          &:hover {
            cursor: pointer;
          }
        }
      }

      .img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }

      .param-list {
        .param-item {
          overflow: hidden;
          line-height: 37px;

          font-size: 12px;
          color: #98a6ad;
          border-bottom: 1px solid rgba(242, 243, 251, 1);
          .param-key {
            float: left;
          }
          .param-val {
            float: right;

            &.state {
              color: #0d9ae0;
            }
          }

          .copy {
            text-decoration: underline;
            float: right;
            margin-left: 10px;
            &:hover {
              cursor: pointer;
            }
          }

          .inner-val {
            max-width: 150px;
            width: auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            float: right;
          }
        }
      }

      .product-desc {
        margin-top: 20px;
        font-size: 12px;
        color: rgba(152, 166, 173, 1);
        line-height: 21px;
        word-break: break-all;
      }
    }

    .component-content {
      flex: 1;
      padding: 24px;
      overflow: hidden;

      .inner-content {
        height: calc(100% - 40px);
        overflow-y: auto;
      }
    }
  }

  .tab {
    ul li {
      border-top: 1px solid #eef2f8;
      line-height: 40px;
      &:nth-child(1) {
        border-left: 1px solid #eef2f8;
      }
      &.current {
        border-top: 2px solid #0d9ae0;
        line-height: 39px;
      }
    }
    .ub-f1 {
      border-top: none;
    }
  }
}
</style>
